import React, { useContext } from 'react';
import { Breadcrumbs } from 'src/components/breadcrumbs';
import { AppContext } from 'src/components/app-context';
import { Product, CategoryPath } from '../../../../types';
import { BreadCrumbWrapper } from './styles';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

export const ProductBreadCrumb: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IProductBreadCrumbProps>
>> = props => {
  const { product } = props;
  const { t } = useContext(AppContext);
  return (
    <BreadCrumbWrapper>
      <Breadcrumbs
        homeText={t('common', 'breadcrumb.home')}
        path={
          product.category?.path
            ? (product.category.path.filter(x => x) as CategoryPath[])
            : []
        }
        firstPathSelectable
        onClick={(nextPage: string) =>
          trackInternalNavigationClick({
            scope: InternalNavigationScope.BREADCRUMB,
            nextPage,
          })
        }
      />
    </BreadCrumbWrapper>
  );
};

interface IProductBreadCrumbProps {
  product: Product;
}
